<script lang="ts" module>
  import { ApiError, type ApiBackendError } from '@/teoCore/errors/ApiError';
  import type { SubscriptionConfig } from '@/teoCore/TeoApi';
  import { TeoCore } from '@/teoCore/TeoCore';
  import type { DropDownLoginItem } from '@/ui/elements/dropdown/DropDownLogin/DropDownLoginSelect.svelte';

  import LoginFooter from './LoginElement/LoginFooter.svelte';
  import LoginGeneral from './LoginElement/LoginGeneral.svelte';
  import LoginResetConfirm from './LoginElement/LoginResetConfirm.svelte';
  import LoginResetPass from './LoginElement/LoginResetPass.svelte';
  import { useAuthState } from './use-auth.svelte';

  export function isApiBackendError(value: unknown): value is ApiBackendError {
    return (value as ApiBackendError).error !== undefined;
  }

  export type PageState = 'loginGeneral' | 'loginResetPass' | 'loginResetConfirm';
  export type UserSelectType = 'email' | 'dropdown' | 'both';

  export type LoginState = {
    userName: string;
    password: string;
    state: PageState;
    mainPage?: PageState;
    resetMail?: string | undefined;
  };
</script>

<script lang="ts">
  let authState = useAuthState();
  let auth = $derived(authState.current);

  let loginState: LoginState = $state({ state: 'loginGeneral', userName: '', password: '' });
  let userSelectType: UserSelectType = $state('email'); // 'email' | 'dropdown' | 'both'

  let userItems: DropDownLoginItem[] = [];

  // Init on startup
  TeoCore.instance.api
    .getSubscriptionConfig(window?.location?.hostname)
    .then((value: SubscriptionConfig | ApiError) => {
      if (isApiBackendError(value) || ApiError.matches(value)) {
        console.error('API-Fehler:', value.error);
      } else {
        loginState.state = 'loginGeneral';
        if (value.use_named_users && value.use_generic_users) {
          userSelectType = 'both';
        } else if (value.use_generic_users) {
          userSelectType = 'dropdown';
        } else {
          userSelectType = 'email';
        }

        if (value.use_generic_users) {
          for (const user of value.generic_users) {
            userItems.push({
              label: user.name,
              value: user.email,
              disabled: !!user.is_logged_in_api,
            });
          }
        }
      }
    });
</script>

{#if !auth.loggedIn}
  <div class="flex h-full flex-col">
    <main
      class="flex h-full flex-1 items-center justify-center rounded-lg bg-gradient-to-b from-login-start to-login-end shadow-login"
    >
      {#if loginState.state === 'loginGeneral'}
        <LoginGeneral {userSelectType} {userItems} bind:loginState></LoginGeneral>
        <!-- {:else if loginState.state === 'loginClient'}
        <LoginClient {allowSwitchToGeneral} {userItems} bind:loginState></LoginClient> -->
      {:else if loginState.state === 'loginResetPass'}
        <LoginResetPass bind:loginState></LoginResetPass>
      {:else if loginState.state === 'loginResetConfirm'}
        <LoginResetConfirm bind:loginState></LoginResetConfirm>
      {/if},
    </main>

    <LoginFooter></LoginFooter>
  </div>
{/if}
